import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useAppDispatch } from '@/shared/model';
import { submitMicrosoftAdsReportingIntegration } from '../../../model/actions';
import { BROADCAST_CHANNEL_NAME } from './constants';

interface UseMicrosoftAdsCodeState {
  processing: boolean;
  openDataAccessDialog: () => void;
}

export const useMicrosoftAdsCode = (): UseMicrosoftAdsCodeState => {
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [processing, setProcessing] = useState(false);

  return {
    processing,
    openDataAccessDialog: () => {
      const clientId = 'd2810bb1-a287-46a8-b9d0-b74f9d117db5';
      const redirectURI = window.location.href;
      const url =
        'https://login.microsoftonline.com/common/oauth2/v2.0/' +
        `authorize?client_id=${clientId}&response_type=code&` +
        `redirect_uri=${redirectURI}&response_mode=query&` +
        `scope=openid%20offline_access%20User.Read%20https%3A%2F%2Fads.microsoft.com%2Fmsads.manage&state=done`;
      const broadcastChannel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
      const dataAccessWindow = window.open(url, '_blank');
      const messageHandler = (event: MessageEvent<{ code: string }>) => {
        const { code } = event.data;

        dataAccessWindow?.close();
        broadcastChannel.removeEventListener('message', messageHandler);

        setProcessing(true);
        dispatch(
          submitMicrosoftAdsReportingIntegration({
            clientId,
            code,
            redirectURI,
          }),
        )
          .catch(() => {
            enqueueSnackbar('Unable to add account. Please, try again.', {
              variant: 'error',
              autoHideDuration: 4000,
            });
          })
          .finally(() => {
            setProcessing(false);
          });
      };

      broadcastChannel.addEventListener('message', messageHandler);
    },
  };
};
